import {
  FaPaw,
  FaHeart,
  FaHospital,
  FaSuitcase,
  FaGlobe,
  FaHandsHelping,
  FaStore,
  FaBroom,
  FaBook,
  FaShieldAlt,
  FaStethoscope,
  FaUserMd,
  FaAmbulance,
  FaDog,
  FaMountain,
  FaHiking,
  FaLuggageCart,
  FaSpider,
  FaHorse,
  FaSyringe,
  FaSearch,
  FaClinicMedical,
  FaFeather,
  FaBed,
  FaStar,
  FaChild,
  FaShoppingBag,
  FaBoxOpen,
  FaWarehouse,
  FaAppleAlt,
  FaTractor,
  FaFrog,
  FaHome,
  FaFish,
  FaBuilding,
  FaLeaf,
  FaHandHoldingHeart,
  FaSmile,
  FaGraduationCap,
  FaCampground,
  FaTree,
  FaBalanceScale,
  FaGavel,
  FaHandshake,
  FaUmbrellaBeach,
  FaClipboardList,
  FaGlobeAmericas,
  FaPlane,
  FaMap,
  FaCalendar,
  FaPhone,
  FaDollarSign,
  FaPhoneAlt,
  FaCloudShowersHeavy,
  FaOtter,
  FaDragon,
  FaCat,
  FaTruckMoving,
  FaUsers,
  FaNewspaper,
  FaFlag,
} from "react-icons/fa";
import { MdLandscape } from "react-icons/md";
import { PiDogFill, PiBirdFill } from "react-icons/pi";
import { 
  GiSeaTurtle, GiBearHead, GiLion, GiMonkey, GiBat, GiWolfHead, 
  GiDeer, GiParrotHead, GiSloth, GiDuck, GiSittingDog, GiElephant, 
  GiKoala, GiRat, GiSquirrel, GiFlyingTrout, GiScissors,
  GiChicken, GiDonkey, GiRabbit, GiSheep, GiGoat
} from "react-icons/gi";
import { HiSparkles } from "react-icons/hi";

// MAIN 5 CATEGORIES - Displayed in the Find Resources carousel

export const mainCategories = [
  // 1. GET EXPERT CARE
  {
    label: "get_expert_care",
    key: "expert",
    action: "popup",
    iconKey: "FaStethoscope",
    description: "get_expert_care_description",
    subcategories: [
      // Veterinarian - has subcategories
      {
        label: "veterinarian",
        key: "veterinarian",
        action: "popup",
        parentKey: "expert",
        iconKey: "FaHospital",
        queryKeyword: "veterinarian near me",
        subcategories: [
          { label: "general_veterinarian", key: "general-veterinarian", action: "query", parentKey: "veterinarian", queryKeyword: "general veterinarian near me", iconKey: "FaStethoscope" },
          { label: "low_cost_vaccinations_clinics", key: "low-cost-veterinarian", action: "query", parentKey: "veterinarian", queryKeyword: "low-cost vet clinics", iconKey: "FaSyringe" },
          { label: "emergency_veterinarian_24_7", key: "emergency-veterinarian", action: "query", parentKey: "veterinarian", queryKeyword: "24 hour emergency vet", iconKey: "FaAmbulance" },
          {
            label: "specialty_veterinarian",
            key: "specialist",
            action: "popup",
            parentKey: "veterinarian",
            iconKey: "FaUserMd",
            queryKeyword: "specialist veterinarian near me",
            subcategories: [
              { label: "avian_veterinarian", key: "avian-veterinarian", action: "query", parentKey: "specialist", queryKeyword: "avian veterinarian near me", iconKey: "PiBirdFill" }, 
              { label: "exotic_animal_veterinarian", key: "exotic-veterinarian", action: "query", parentKey: "specialist", queryKeyword: "exotic animal veterinarian", iconKey: "FaSpider" }, 
              { label: "equine_veterinarian", key: "equine-veterinarian", action: "query", parentKey: "specialist", queryKeyword: "equine veterinarian", iconKey: "FaHorse" }, 
              { label: "small_animal_specialist", key: "small-animal-veterinarian", action: "query", parentKey: "specialist", queryKeyword: "small animal specialist vet", iconKey: "PiDogFill" }
            ]
          }
        ]
      },
      // Military Veterinary Services
      {
        label: "military_veterinary_services",
        key: "military-vet",
        action: "query",
        parentKey: "expert",
        iconKey: "FaShieldAlt",
        queryKeyword: "military veterinary services near me",
      },
      // Groomers
      {
        label: "groomers",
        key: "groomer",
        action: "popup",
        parentKey: "expert",
        queryKeyword: "pet groomer",
        iconKey: "GiScissors",
        subcategories: [
          { label: "groomers", key: "pet-groomer", action: "query", parentKey: "groomer", queryKeyword: "pet groomer", iconKey: "FaBroom" },
          { label: "mobile_pet_groomers", key: "mobile_pet_groomer", action: "query", parentKey: "groomer", queryKeyword: "mobile pet groomer", iconKey: "FaTruckMoving" },
        ]
      },
      // Pet Training & Behavior Help
      {
        label: "pet_training_behavior",
        key: "training-tips-resources",
        action: "popup",
        parentKey: "expert",
        iconKey: "FaGraduationCap",
        queryKeyword: "pet training facilities near me",
        subcategories: [
          { label: "dog_training_facilities", key: "dog-training-facilities", action: "query", parentKey: "training-tips-resources", queryKeyword: "dog training facilities near me", iconKey: "FaDog" },
          { label: "obedience_training", key: "obedience-training", action: "query", parentKey: "training-tips-resources", queryKeyword: "dog obedience training near me", iconKey: "FaClipboardList" },
          { label: "service_dog_training", key: "service-dog-training", action: "query", parentKey: "training-tips-resources", queryKeyword: "service dog training programs", iconKey: "FaHandsHelping" },
          { label: "behavioral_specialists", key: "behavioral-specialists", action: "query", parentKey: "training-tips-resources", queryKeyword: "animal behavioral specialists near me", iconKey: "FaUserMd" },
          { label: "puppy_training_classes", key: "puppy-training-classes", action: "query", parentKey: "training-tips-resources", queryKeyword: "puppy training classes near me", iconKey: "FaChild" },
          { label: "exotic_animal_training", key: "exotic-animal-training", action: "query", parentKey: "training-tips-resources", queryKeyword: "exotic animal training specialists", iconKey: "FaSpider" },
          { label: "equine_training", key: "equine-training", action: "query", parentKey: "training-tips-resources", queryKeyword: "horse training facilities near me", iconKey: "FaHorse" }
        ]
      },
    ],
  },

  // 2. BOARDING & SUPPLIES
  {
    label: "boarding_supplies",
    key: "boarding",
    action: "popup",
    iconKey: "FaStore",
    description: "boarding_supplies_description",
    subcategories: [
      // Pet Stores
      {
        label: "pet_stores",
        key: "pet-store",
        action: "popup",
        parentKey: "boarding",
        iconKey: "FaStore",
        queryKeyword: "pet stores near me",
        subcategories: [
          { label: "local_pet_stores", key: "local-pet-stores", action: "query", parentKey: "pet-store", queryKeyword: "local pet stores", iconKey: "FaShoppingBag" },
          { label: "animal_supplies", key: "animal-supplies", action: "query", parentKey: "pet-store", queryKeyword: "animal supplies store", iconKey: "FaBoxOpen" },
          { label: "feed_stores", key: "feed-stores", action: "query", parentKey: "pet-store", queryKeyword: "livestock feed stores", iconKey: "FaWarehouse" },
          { label: "pet_food_health", key: "pet-food-health", action: "query", parentKey: "pet-store", queryKeyword: "pet food and health stores", iconKey: "FaAppleAlt" },
          { label: "avian_supplies_food", key: "avian-supplies", action: "query", parentKey: "pet-store", queryKeyword: "bird food and supplies store", iconKey: "PiBirdFill" }
        ]
      },
      // Boarding & Daycare
      {
        label: "boarding_and_daycare",
        key: "boarding-daycare",
        action: "popup",
        parentKey: "boarding",
        iconKey: "FaBed",
        queryKeyword: "pet boarding and daycare near me",
        subcategories: [
          { label: "boarding_services", key: "boarding", action: "query", parentKey: "boarding-daycare", queryKeyword: "pet boarding services overnight", iconKey: "FaBed" },
          { label: "daycare_services", key: "daycare", action: "query", parentKey: "boarding-daycare", queryKeyword: "pet daycare services", iconKey: "FaChild" },
          { label: "specialized_boarding_daycare", key: "specialized-boarding", action: "query", parentKey: "boarding-daycare", queryKeyword: "specialized pet boarding and daycare", iconKey: "FaStar" },
          { label: "pet_sitter", key: "pet-sitter", action: "query", parentKey: "boarding-daycare", queryKeyword: "pet sitter", iconKey: "GiSittingDog" }
        ]
      },
      // Military Pet Boarding
      {
        label: "military_pet_boarding",
        key: "military-boarding",
        action: "query",
        parentKey: "boarding",
        iconKey: "FaHome",
        queryKeyword: "military pet boarding near me",
      },
      // Deployment Pet Support
      {
        label: "deployment_pet_support",
        key: "deployment-support",
        action: "query",
        parentKey: "boarding",
        iconKey: "FaShieldAlt",
        queryKeyword: "deployment pet foster care",
      },
    ],
  },

  // 3. PLACES TO GO
  {
    label: "places_to_go",
    key: "places",
    action: "popup",
    iconKey: "FaMap",
    description: "places_to_go_description",
    subcategories: [
      // Dog Parks
      {
        label: "dog_parks",
        key: "dog-park",
        action: "query",
        parentKey: "places",
        queryKeyword: "dog parks near me",
        iconKey: "FaPaw",
      },
      // Animal Sanctuaries
      {
        label: "sanctuaries",
        key: "animal-sanctuary",
        action: "popup",
        parentKey: "places",
        iconKey: "MdLandscape",
        queryKeyword: "animal sanctuaries near me",
        subcategories: [
          {
            label: "wildlife_sanctuaries",
            key: "wildlife-sanctuary",
            action: "popup",
            parentKey: "animal-sanctuary",
            iconKey: "FaPaw",
            queryKeyword: "wildlife sanctuaries near me",
            subcategories: [
              { label: "mammal_sanctuaries", key: "mammal-sanctuary", action: "query", parentKey: "wildlife-sanctuary", queryKeyword: "mammal sanctuary near me", iconKey: "GiWolfHead" },
              { label: "deer_hoofed_animal_sanctuaries", key: "deer-sanctuary", action: "query", parentKey: "wildlife-sanctuary", queryKeyword: "deer sanctuary near me", iconKey: "GiDeer" },
              { label: "otter_aquatic_mammal_sanctuaries", key: "otter-sanctuary", action: "query", parentKey: "wildlife-sanctuary", queryKeyword: "otter sanctuary near me", iconKey: "FaOtter" },
              { label: "duck_waterfowl_sanctuaries", key: "duck-sanctuary", action: "query", parentKey: "wildlife-sanctuary", queryKeyword: "duck and waterfowl sanctuaries near me", iconKey: "GiDuck" }
            ]
          },
          {
            label: "farm_animal_sanctuaries",
            key: "farm-animal-sanctuary",
            action: "popup",
            parentKey: "animal-sanctuary",
            iconKey: "FaTractor",
            queryKeyword: "farm animal sanctuaries near me",
            subcategories: [
              { label: "pig_sanctuaries", key: "pig-sanctuary", action: "query", parentKey: "farm-animal-sanctuary", queryKeyword: "pig sanctuary near me", iconKey: "FaPaw" },
              { label: "cow_cattle_sanctuaries", key: "cow-sanctuary", action: "query", parentKey: "farm-animal-sanctuary", queryKeyword: "cow cattle sanctuary near me", iconKey: "FaPaw" },
              { label: "sheep_sanctuaries", key: "sheep-sanctuary", action: "query", parentKey: "farm-animal-sanctuary", queryKeyword: "sheep sanctuary near me", iconKey: "GiSheep" },
              { label: "goat_sanctuaries", key: "goat-sanctuary", action: "query", parentKey: "farm-animal-sanctuary", queryKeyword: "goat sanctuary near me", iconKey: "GiGoat" },
              { label: "horse_donkey_sanctuaries", key: "horse-donkey-sanctuary", action: "query", parentKey: "farm-animal-sanctuary", queryKeyword: "horse donkey mule sanctuary near me", iconKey: "FaHorse" },
              { label: "chicken_hen_sanctuaries", key: "chicken-sanctuary", action: "query", parentKey: "farm-animal-sanctuary", queryKeyword: "chicken hen poultry sanctuary near me", iconKey: "GiChicken" },
              { label: "turkey_sanctuaries", key: "turkey-sanctuary", action: "query", parentKey: "farm-animal-sanctuary", queryKeyword: "turkey sanctuary near me", iconKey: "FaFeather" },
              { label: "duck_goose_sanctuaries", key: "duck-goose-sanctuary", action: "query", parentKey: "farm-animal-sanctuary", queryKeyword: "duck goose waterfowl sanctuary near me", iconKey: "GiDuck" },
              { label: "alpaca_llama_sanctuaries", key: "alpaca-llama-sanctuary", action: "query", parentKey: "farm-animal-sanctuary", queryKeyword: "alpaca llama camelid sanctuary near me", iconKey: "FaPaw" },
              { label: "rabbit_sanctuaries", key: "rabbit-sanctuary", action: "query", parentKey: "farm-animal-sanctuary", queryKeyword: "rabbit sanctuary near me", iconKey: "GiRabbit" }
            ]
          },
          {
            label: "exotic_animal_sanctuaries",
            key: "exotic-animal-sanctuary",
            action: "popup",
            parentKey: "animal-sanctuary",
            iconKey: "FaGlobe",
            queryKeyword: "exotic animal sanctuaries near me",
            subcategories: [
              { label: "primate_sanctuaries", key: "primate-sanctuary", action: "query", parentKey: "exotic-animal-sanctuary", queryKeyword: "primate sanctuary near me", iconKey: "GiMonkey" },
              { label: "parrot_exotic_bird_sanctuaries", key: "parrot-sanctuary", action: "query", parentKey: "exotic-animal-sanctuary", queryKeyword: "parrot sanctuary near me", iconKey: "GiParrotHead" },
              { label: "sloth_rainforest_animal_sanctuaries", key: "sloth-sanctuary", action: "query", parentKey: "exotic-animal-sanctuary", queryKeyword: "sloth sanctuary near me", iconKey: "GiSloth" },
              { label: "elephant_sanctuaries", key: "elephant-sanctuary", action: "query", parentKey: "exotic-animal-sanctuary", queryKeyword: "elephant sanctuary near me", iconKey: "GiElephant" }, 
              { label: "koala_sanctuaries", key: "koala-sanctuary", action: "query", parentKey: "exotic-animal-sanctuary", queryKeyword: "koala sanctuary near me", iconKey: "GiKoala" }
            ]
          },
          { label: "domestic_animal_sanctuaries", key: "domestic-animal-sanctuary", action: "query", parentKey: "animal-sanctuary", queryKeyword: "domestic animal sanctuaries", iconKey: "FaHome" },
          { label: "herpetological_sanctuaries", key: "herp-sanctuary", action: "query", parentKey: "animal-sanctuary", queryKeyword: "reptile and amphibian sanctuaries", iconKey: "FaFrog" },
          { label: "avian_sanctuaries", key: "avian-sanctuary", action: "query", parentKey: "animal-sanctuary", queryKeyword: "bird and avian sanctuaries", iconKey: "PiBirdFill" },
          { label: "lions_tigers_bears_sanctuary", key: "big-cats-bears-sanctuary", action: "query", parentKey: "animal-sanctuary", queryKeyword: "big cat and bear sanctuaries", iconKey: "GiLion" }
        ]
      },
      // Animal Encounters & Camps
      {
        label: "animal_encounters_and_camps",
        key: "animal-encounters-camps",
        action: "popup",
        parentKey: "places",
        iconKey: "FaCampground",
        queryKeyword: "animal encounters and camps near me",
        subcategories: [
          { label: "animal_encounters", key: "animal-encounters", action: "query", parentKey: "animal-encounters-camps", queryKeyword: "best animal encounters", iconKey: "FaHandHoldingHeart" },
          { label: "interactive_animal_experiences", key: "interactive-animal-experiences", action: "query", parentKey: "animal-encounters-camps", queryKeyword: "interactive animal experiences", iconKey: "FaSmile" },
          { label: "duck_waterfowl_encounters", key: "duck-encounters", action: "query", parentKey: "animal-encounters-camps", queryKeyword: "duck and waterfowl encounters near me", iconKey: "GiDuck" },
          { label: "conservation_programs", key: "animal-conservation-programs", action: "query", parentKey: "animal-encounters-camps", queryKeyword: "wildlife conservation programs", iconKey: "FaLeaf" },
          { label: "animal_camps_for_kids", key: "animal-camps", action: "query", parentKey: "animal-encounters-camps", queryKeyword: "animal summer camps for kids", iconKey: "FaChild" }
        ]
      },
      // Pet Travel & Safety
      {
        label: "pet_travel_safety",
        key: "travel",
        action: "popup",
        parentKey: "places",
        iconKey: "FaPlane",
        queryKeyword: "pet-friendly travel options near me",
        subcategories: [
          { label: "pet_friendly_hotels", key: "pet-friendly-hotels", action: "query", parentKey: "travel", queryKeyword: "pet-friendly hotels near me", iconKey: "FaBed" },
          { label: "pet_transportation_services", key: "pet-transportation", action: "query", parentKey: "travel", queryKeyword: "pet transport services near me", iconKey: "FaAmbulance" },
          { label: "pet_friendly_camping", key: "pet-friendly-camping", action: "query", parentKey: "travel", queryKeyword: "pet-friendly campgrounds near me", iconKey: "FaCampground" }
        ]
      },
      // Zoos, Safaris & Aquariums
      {
        label: "zoos_safaris_aquariums",
        key: "zoos-safaris-aquariums",
        action: "popup",
        parentKey: "places",
        iconKey: "FaFish",
        queryKeyword: "zoos, safaris, and aquariums near me",
        subcategories: [
          { label: "accredited_zoos_safaris_aquariums", key: "accredited-zoos", action: "query", parentKey: "zoos-safaris-aquariums", queryKeyword: "accredited zoos and aquariums", iconKey: "FaShieldAlt" },
          { label: "traditional_zoos", key: "traditional-zoos", action: "query", parentKey: "zoos-safaris-aquariums", queryKeyword: "traditional zoos near me", iconKey: "FaBuilding" },
          { label: "safari_parks_wildlife_reserves", key: "safari-parks", action: "query", parentKey: "zoos-safaris-aquariums", queryKeyword: "safari parks and wildlife reserves", iconKey: "FaTree" },
          { label: "aquariums_marine_parks", key: "aquariums-marine", action: "query", parentKey: "zoos-safaris-aquariums", queryKeyword: "aquariums and marine parks", iconKey: "FaFish" },
          { label: "rehabilitation_conservation_centers", key: "rehab-conservation", action: "query", parentKey: "zoos-safaris-aquariums", queryKeyword: "wildlife rehabilitation and conservation centers", iconKey: "FaHandsHelping" },
          { label: "interactive_educational_animal_parks", key: "interactive-animal-parks", action: "query", parentKey: "zoos-safaris-aquariums", queryKeyword: "interactive and educational animal parks", iconKey: "FaGraduationCap" },
          { label: "duck_waterfowl_habitats", key: "duck-habitats", action: "query", parentKey: "zoos-safaris-aquariums", queryKeyword: "zoos with duck habitats near me", iconKey: "GiDuck" },
          { label: "sanctuary_zoos_aquariums", key: "sanctuary-zoos", action: "query", parentKey: "zoos-safaris-aquariums", queryKeyword: "sanctuary-based zoos and aquariums", iconKey: "FaGlobe" }
        ]
      },
      // Pet Adventures
      {
        label: "pet_adventures",
        key: "adventures",
        action: "popup",
        parentKey: "places",
        iconKey: "FaMountain",
        queryKeyword: "pet-friendly outdoor activities near me",
        subcategories: [
          { label: "dog_friendly_hiking_trails", key: "hiking-trails", action: "query", parentKey: "adventures", queryKeyword: "dog-friendly hiking trails", iconKey: "FaHiking" },
          { label: "pet_insurance", key: "pet-insurance", action: "query", parentKey: "adventures", queryKeyword: "pet insurance companies", iconKey: "FaShieldAlt" },
          { label: "dog_beaches", key: "dog-beaches", action: "query", parentKey: "adventures", queryKeyword: "dog-friendly beaches", iconKey: "FaUmbrellaBeach" },
          { label: "pet_friendly_camping", key: "camping", action: "query", parentKey: "adventures", queryKeyword: "pet-friendly campgrounds", iconKey: "FaCampground" },
          { label: "adventure_preparation_tips", key: "adventure-tips", action: "query", parentKey: "adventures", queryKeyword: "pet travel and adventure tips", iconKey: "FaClipboardList" }
        ]
      },
    ],
  },

  // 4. ADOPTION & RESCUE
  {
    label: "adoption_rescue",
    key: "adoption",
    action: "popup",
    iconKey: "FaHeart",
    description: "adoption_rescue_description",
    subcategories: [
      // Animal Shelters
      {
        label: "animal_shelters",
        key: "animal-shelter",
        action: "popup",
        parentKey: "adoption",
        iconKey: "FaHome",
        queryKeyword: "animal shelters near me",
        subcategories: [
          { label: "local_shelters", key: "local-animal-shelter", action: "query", parentKey: "animal-shelter", queryKeyword: "local animal shelters", iconKey: "PiDogFill" },
          {
            label: "specialty_shelters",
            key: "specialty-animal-shelter",
            action: "popup",
            parentKey: "animal-shelter",
            iconKey: "FaPaw",
            queryKeyword: "specialty animal shelters near me",
            subcategories: [
              { label: "dog_shelters_and_adoption_centers", key: "dog-shelter", action: "query", parentKey: "specialty-animal-shelter", queryKeyword: "dog shelter near me", iconKey: "FaDog" },
              { label: "cat_only_shelters_and_rescues", key: "cat-shelter", action: "query", parentKey: "specialty-animal-shelter", queryKeyword: "cat shelter near me", iconKey: "FaCat" },
              { label: "exotic_bird_and_parrot_shelters", key: "bird-shelter", action: "query", parentKey: "specialty-animal-shelter", queryKeyword: "exotic bird shelter near me", iconKey: "GiParrotHead" },
              { label: "reptile_and_amphibian_shelters", key: "reptile-shelter", action: "query", parentKey: "specialty-animal-shelter", queryKeyword: "reptile shelter near me", iconKey: "FaDragon" },
              { label: "turtle_and_tortoise_shelters", key: "turtle-shelter", action: "query", parentKey: "specialty-animal-shelter", queryKeyword: "turtle shelter near me", iconKey: "GiSeaTurtle" },
              { label: "equine_and_horse_rescue_shelters", key: "equine-shelter", action: "query", parentKey: "specialty-animal-shelter", queryKeyword: "horse shelter shelter near me", iconKey: "FaHorse" },
              { label: "small_mammal_shelters", key: "small-mammal-shelter", action: "query", parentKey: "specialty-animal-shelter", queryKeyword: "small mammal shelter near me", iconKey: "FaOtter" }
            ]
          },
          { label: "tnr_programs", key: "tnr", action: "query", parentKey: "animal-shelter", queryKeyword: "trap neuter return programs", iconKey: "FaClinicMedical" }
        ]
      },
      // No-Kill Shelters
      {
        label: "no_kill_shelters",
        key: "no-kill-shelters",
        action: "popup",
        parentKey: "adoption",
        iconKey: "HiSparkles",
        queryKeyword: "no-kill animal shelters near me",
        subcategories: [
          {
            label: "local_no_kill_shelters",
            key: "local-no-kill-shelter",
            action: "popup",
            parentKey: "no-kill-shelters",
            iconKey: "FaHome",
            queryKeyword: "local no-kill animal shelters near me",
            subcategories: [
              { label: "no_kill_dog_shelters", key: "no-kill-dog-shelter", action: "query", parentKey: "local-no-kill-shelter", queryKeyword: "no-kill dog shelters near me", iconKey: "FaDog" },
              { label: "no_kill_cat_shelters", key: "no-kill-cat-shelter", action: "query", parentKey: "local-no-kill-shelter", queryKeyword: "no-kill cat shelters near me", iconKey: "FaCat" },
              { label: "no_kill_bird_sanctuaries", key: "no-kill-bird-shelter", action: "query", parentKey: "local-no-kill-shelter", queryKeyword: "no-kill bird rescue near me", iconKey: "GiParrotHead" },
              { label: "no_kill_reptile_sanctuaries", key: "no-kill-reptile-shelter", action: "query", parentKey: "local-no-kill-shelter", queryKeyword: "no-kill reptile sanctuary near me", iconKey: "FaDragon" },
              { label: "no_kill_equine_farm_sanctuaries", key: "no-kill-equine-shelter", action: "query", parentKey: "local-no-kill-shelter", queryKeyword: "no-kill horse and farm animal sanctuary near me", iconKey: "FaHorse" }
            ]
          },
          {
            label: "global_no_kill_shelters",
            key: "global-no-kill-shelter",
            action: "popup",
            parentKey: "no-kill-shelters",
            iconKey: "FaGlobe",
            queryKeyword: "global no-kill animal shelters",
            subcategories: [
              { label: "best_friends_animal_society_us", key: "best-friends-society", action: "externalLink", url: "https://bestfriends.org/", iconKey: "FaHandHoldingHeart" },
              { label: "european_no_kill_animal_shelters", key: "europe-no-kill", action: "query", parentKey: "global-no-kill-shelter", queryKeyword: "European no-kill animal shelters", iconKey: "FaGlobeAmericas" },
              { label: "australian_no_kill_animal_sanctuaries", key: "australia-no-kill", action: "query", parentKey: "global-no-kill-shelter", queryKeyword: "Australian no-kill animal sanctuaries", iconKey: "FaTree" },
              { label: "latin_american_no_kill_shelters", key: "latin-america-no-kill", action: "query", parentKey: "global-no-kill-shelter", queryKeyword: "Latin American no-kill animal shelters", iconKey: "FaLeaf" },
              { label: "international_no_kill_shelter_coalition", key: "global-no-kill-coalition", action: "query", parentKey: "global-no-kill-shelter", queryKeyword: "international no-kill animal shelters", iconKey: "FaGlobe" }
            ]
          }
        ]
      },
      // Animal Rescues
      {
        label: "animal_rescues",
        key: "rescue",
        action: "popup",
        parentKey: "adoption",
        iconKey: "FaHandHoldingHeart",
        queryKeyword: "animal rescue near me",
        subcategories: [
          { label: "local_animal_rescue", key: "local-rescue", action: "query", parentKey: "rescue", queryKeyword: "local animal rescue", iconKey: "FaDog" },
          {
            label: "wildlife_rescue_rehabilitation",
            key: "wildlife-rescue",
            action: "popup",
            parentKey: "rescue",
            iconKey: "FaFeather",
            queryKeyword: "wildlife rescue near me",
            subcategories: [
              { label: "bird_rescue", key: "bird-rescue", action: "query", parentKey: "wildlife-rescue", queryKeyword: "wild bird rescue near me", iconKey: "PiBirdFill" },
              { label: "mammal_rescue", key: "mammal-rescue", action: "query", parentKey: "wildlife-rescue", queryKeyword: "wildlife mammal rescue near me", iconKey: "FaOtter" },
              { label: "reptile_amphibian_rescue", key: "reptile-amphibian-rescue", action: "query", parentKey: "wildlife-rescue", queryKeyword: "reptile and amphibian rescue near me", iconKey: "FaDragon" },
              { label: "marine_wildlife_rescue", key: "marine-wildlife-rescue", action: "query", parentKey: "wildlife-rescue", queryKeyword: "marine animal rescue near me", iconKey: "FaFish" }
            ]
          },
          { label: "farm_animal_rescue", key: "farm-animal-rescue", action: "query", parentKey: "rescue", queryKeyword: "farm animal rescue", iconKey: "FaHorse" },
          {
            label: "specialty_rescue",
            key: "specialty-animal-rescue",
            action: "popup",
            parentKey: "rescue",
            iconKey: "FaPaw",
            queryKeyword: "specialty animal rescue",
            subcategories: [
              { label: "turtle_tortoise_rescue", key: "turtle-rescue", action: "query", parentKey: "specialty-animal-rescue", queryKeyword: "turtle and tortoise rescue near me", iconKey: "GiSeaTurtle" },
              { label: "bear_rescue", key: "bear-rescue", action: "query", parentKey: "specialty-animal-rescue", queryKeyword: "bear rescue center near me", iconKey: "GiBearHead" },
              { label: "big_cat_rescue", key: "big-cat-rescue", action: "query", parentKey: "specialty-animal-rescue", queryKeyword: "big cat rescue near me", iconKey: "GiLion" },
              { label: "primate_rescue", key: "primate-rescue", action: "query", parentKey: "specialty-animal-rescue", queryKeyword: "primate rescue near me", iconKey: "GiMonkey" },
              { label: "bat_rescue", key: "bat-rescue", action: "query", parentKey: "specialty-animal-rescue", queryKeyword: "bat rescue center near me", iconKey: "GiBat" },
              { label: "chinchilla_rescue", key: "chinchilla-rescue", action: "query", parentKey: "specialty-animal-rescue", queryKeyword: "chinchilla rescue near me", iconKey: "GiRat" },
              { label: "sugar_glider_rescue", key: "sugar-glider-rescue", action: "query", parentKey: "specialty-animal-rescue", queryKeyword: "sugar glider rescue near me", iconKey: "GiFlyingTrout" },
              { label: "hamster_rescue", key: "hamster-rescue", action: "query", parentKey: "specialty-animal-rescue", queryKeyword: "hamster rescue near me", iconKey: "GiRat" },
              { label: "squirrel_rescue", key: "squirrel-rescue", action: "query", parentKey: "specialty-animal-rescue", queryKeyword: "squirrel rescue near me", iconKey: "GiSquirrel" }
            ]
          },
        ]
      },
    ],
  },

  // 5. COMMUNITY HUB
  {
    label: "community_hub",
    key: "community",
    action: "popup",
    iconKey: "FaUsers",
    description: "community_hub_description",
    subcategories: [
      // Animal Welfare & Advocacy
      {
        label: "animal_welfare_advocacy",
        key: "animal-welfare-advocacy",
        action: "popup",
        parentKey: "community",
        iconKey: "FaHandHoldingHeart",
        queryKeyword: "animal welfare organizations near me",
        subcategories: [
          { label: "animal_welfare_leagues", key: "animal-welfare-league", action: "query", parentKey: "animal-welfare-advocacy", queryKeyword: "animal welfare leagues", iconKey: "FaBalanceScale" },
          { label: "humane_societies", key: "humane-society", action: "query", parentKey: "animal-welfare-advocacy", queryKeyword: "humane societies near me", iconKey: "FaShieldAlt" },
          { label: "animal_protection_advocacy_groups", key: "protection-advocacy", action: "query", parentKey: "animal-welfare-advocacy", queryKeyword: "animal protection advocacy groups", iconKey: "FaGavel" },
          { label: "non_profit_rescue_organizations", key: "nonprofit-animal-rescue", action: "query", parentKey: "animal-welfare-advocacy", queryKeyword: "nonprofit animal rescue organizations", iconKey: "FaHandshake" },
          { label: "spay_neuter_programs", key: "spay-neuter", action: "query", parentKey: "animal-welfare-advocacy", queryKeyword: "spay and neuter programs", iconKey: "FaClinicMedical" },
          {
            label: "top_rated_animal_charities",
            key: "top-animal-charities",
            action: "externalLink",
            url: "https://www.animalcharityevaluators.org/",
            iconKey: "FaHeart"
          },
          {
            label: "global_animal_welfare_organizations",
            key: "global-animal-welfare",
            action: "externalLink",
            url: "https://www.ifaw.org/",
            iconKey: "FaGlobe"
          },
          {
            label: "wildlife_conservation_protection",
            key: "wildlife-conservation",
            action: "externalLink",
            url: "https://www.worldwildlife.org/",
            iconKey: "FaTree"
          },
        ]
      },
      // Conventions & Events
      {
        label: "animal_conventions_events",
        key: "conventions",
        action: "popup",
        parentKey: "community",
        iconKey: "FaFlag",
        subcategories: [
          { label: "pet_industry_trade_shows", key: "pet-trade-shows", action: "externalLink", url: "https://globalpetexpo.org", iconKey: "FaShoppingBag" },
          { label: "veterinary_conferences", key: "veterinary-conferences", action: "externalLink", url: "https://navc.com/vmx/", iconKey: "FaUserMd" },
          { label: "animal_welfare_advocacy_events", key: "animal-welfare-events", action: "externalLink", url: "https://www.animalsheltering.org/expo", iconKey: "FaHandsHelping" },
          { label: "wildlife_conservation_conferences", key: "wildlife-conservation-events", action: "externalLink", url: "https://wildnet.org/events/", iconKey: "FaGlobe" },
          { label: "rescue_adoption_events", key: "rescue-adoption-events", action: "externalLink", url: "https://bestfriends.org/events", iconKey: "FaHeart" }
        ]
      },
      // Community News & Networking
      {
        label: "community_news_networking",
        key: "community-news",
        action: "query",
        parentKey: "community",
        iconKey: "FaNewspaper",
        queryKeyword: "local animal community groups",
      },
    ],
  },
];

// For backward compatibility, also export as resourceCategories
export const resourceCategories = mainCategories;

// Icon Map - Maps icon key strings to actual React icon components
export const iconMap = {
  PiDogFill: <PiDogFill />,
  MdLandscape: <MdLandscape />,
  FaHeart: <FaHeart />,
  FaPaw: <FaPaw />,
  FaHospital: <FaHospital />,
  FaSuitcase: <FaSuitcase />,
  FaGlobe: <FaGlobe />,
  FaHandsHelping: <FaHandsHelping />,
  FaStore: <FaStore />,
  FaBroom: <FaBroom />,
  FaBook: <FaBook />,
  FaShieldAlt: <FaShieldAlt />,
  FaStethoscope: <FaStethoscope />,
  FaUserMd: <FaUserMd />,
  FaAmbulance: <FaAmbulance />,
  FaDog: <FaDog />,
  FaMountain: <FaMountain />,
  FaHiking: <FaHiking />,
  FaLuggageCart: <FaLuggageCart />,
  FaSyringe: <FaSyringe />,
  FaSpider: <FaSpider />,
  FaHorse: <FaHorse />,
  PiBirdFill: <PiBirdFill />,
  FaSearch: <FaSearch />,
  FaClinicMedical: <FaClinicMedical />,
  FaFeather: <FaFeather />,
  FaBed: <FaBed />,
  FaStar: <FaStar />,
  FaChild: <FaChild />,
  FaShoppingBag: <FaShoppingBag />,
  FaBoxOpen: <FaBoxOpen />,
  FaWarehouse: <FaWarehouse />,
  FaAppleAlt: <FaAppleAlt />,
  FaTractor: <FaTractor />,
  FaFrog: <FaFrog />,
  FaHome: <FaHome />,
  FaFish: <FaFish />,
  FaBuilding: <FaBuilding />,
  FaLeaf: <FaLeaf />,
  FaHandHoldingHeart: <FaHandHoldingHeart />,
  FaSmile: <FaSmile />,
  FaGraduationCap: <FaGraduationCap />,
  FaCampground: <FaCampground />,
  FaTree: <FaTree />,
  FaBalanceScale: <FaBalanceScale />,
  FaGavel: <FaGavel />,
  FaHandshake: <FaHandshake />,
  FaUmbrellaBeach: <FaUmbrellaBeach />,
  FaClipboardList: <FaClipboardList />,
  FaGlobeAmericas: <FaGlobeAmericas />,
  FaPlane: <FaPlane />,
  FaMap: <FaMap />,
  FaCalendar: <FaCalendar />,
  FaPhone: <FaPhone />,
  FaDollarSign: <FaDollarSign />,
  FaPhoneAlt: <FaPhoneAlt />,
  FaCloudShowersHeavy: <FaCloudShowersHeavy />,
  FaOtter: <FaOtter />,
  FaDragon: <FaDragon />,
  GiBearHead: <GiBearHead />,
  GiLion: <GiLion />,
  GiMonkey: <GiMonkey />,
  GiSeaTurtle: <GiSeaTurtle />,
  GiBat: <GiBat />,
  GiWolfHead: <GiWolfHead />,
  GiDeer: <GiDeer />,
  GiSloth: <GiSloth />,
  GiParrotHead: <GiParrotHead />,
  FaCat: <FaCat />,
  GiDuck: <GiDuck />,
  FaTruckMoving: <FaTruckMoving />,
  GiSittingDog: <GiSittingDog />,
  GiElephant: <GiElephant />,
  GiKoala: <GiKoala />,
  GiRat: <GiRat />,
  GiFlyingTrout: <GiFlyingTrout />,
  GiSquirrel: <GiSquirrel />,
  GiScissors: <GiScissors />,
  HiSparkles: <HiSparkles />,
  FaUsers: <FaUsers />,
  FaNewspaper: <FaNewspaper />,
  FaFlag: <FaFlag />,
  GiChicken: <GiChicken />,
  GiDonkey: <GiDonkey />,
  GiRabbit: <GiRabbit />,
  GiSheep: <GiSheep />,
  GiGoat: <GiGoat />,
};
